const initialState = {
  validationErrors: null,
};

export default initialState;
